import { getText } from '../../services/localization.js';

import styles from './WhoWeAre.module.css';

export const WhoWeAre = () => {
  return(
    <div className={styles.whoWeAreContent}>
      <div className="container">
        <h1>{getText('من نحن؟', 'WHO WE ARE?')}</h1>
        <div className={styles.wrapper}>
          <div className={styles.description}>
            <p>
              {getText(
                `تأسست شركة ابو شقدم في عام 1996 وكانت من اوائل الشركات المتخصصة في 
                 صناعة المعادن والاشغال الحديدية وفي عام ٢٠٠٦
                 تم افتتاح المقر الجديد للشركة في
                 خلدا حيث طورت الشركة منتج جديد في ذلك الوقت في عالم الابواب وهو أبواب
                الامان المتعددة الاغلاق ولتلبية حاجة السوق المحلي من هذا النوع من الابواب تم بناء
                
                مصنع للشركة بمساحة
                4000
                متر مربع وتجهيزه باحدث االآلت والماكنات الصناعية الالمانية والتركية الصنع، واستقطاب
                العمالة الفنية المؤهلة حيث اصبح الكادر التشغيلي والاداري للشركة ما يقارب
                 ال٦٥ موضفاً
                 `,
                `Since its establishment in 1996 , Abu Shaqdam Brothers have been in the line of manufacturing
                special doors. In 2006 Tayseer Abu Shaqdam For Security Doors company has evolved as a
                leading specialized manufacturer for security doors with a new corporate identity and under a
                new name of Abu Shaqdam For Security Doors.” SD” , Focusing on the development , production
                and marketing of high quality security doors and indoors serving the local market.
                Abu Shaqdam For Security Doors Company . is located in its new facility in Amman – Marka On
                4000 Sq meters and opened its new head quarter in 2004 in Khalda .
                In addition to its sales team and top management , Abu Shaqdam For Security Doors employee
                around 65 skilled labours.`
              )}
            </p>
          </div>
          <div className={styles.bg}></div>
        </div>
      </div>
    </div>
  )
}